import { APICore } from './apiCore'

const api = new APICore()


export function fetchAppInfo(params: { typeId: number}) { // 1: About App, 2: Privacy Policy, 3: Terms of Services
	const baseUrl = '/getAppInfo'
	return api.get(`${baseUrl}`, params)
}